<template>
  <div class="page-header-logo">
    <a :href="homeUrl">
      <!-- <img class="page-header-logo-image" :src="logo" @error="onLogoError" alt="Article"> -->
      <div class="page-header-logo-image">
        <svg id="Layer_1" aria-labelledby="title" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 78">
          <title id="title" lang="en">Article</title>
          <path
            d="M57.76,62H22.29l-5.5,14.44H2.42L31.83,1.24H43.35A7.14,7.14,0,0,1,50,5.79L77.63,76.46H63.26ZM26,50.41H54.06l-14-38Z"
            transform="translate(-2.42)"
            style="fill:#8a8a8d"
          />
          <path
            d="M134.42,48.38h-13V76.46H108.27V1.24h32.89c14.82,0,24.47,9.7,24.47,23.57,0,13.42-8.76,20.64-17.73,22.1l18.3,29.55H151Zm4.94-35.52h-18V36.77h18c7.41,0,12.8-4.74,12.8-12S146.77,12.86,139.36,12.86Z"
            transform="translate(-2.42)"
            style="fill:#8a8a8d"
          />
          <path
            d="M215.73,12.86H193.06V8.42a7.16,7.16,0,0,1,7.14-7.17h51.34V12.86H228.87V76.46H215.73V12.86Z"
            transform="translate(-2.42)"
            style="fill:#8a8a8d"
          />
          <path d="M281.79,1.24h6a7.16,7.16,0,0,1,7.14,7.17v68H281.79V1.24Z" transform="translate(-2.42)" style="fill:#8a8a8d" />
          <path
            d="M325.54,38.91C325.54,15.79,342.71,0,364.27,0c15.71,0,25,7.89,30.64,16.92l-11.22,5.75a22.44,22.44,0,0,0-19.42-10.94C350,11.73,339,23.12,339,38.91s11,27.18,25.26,27.18a22.21,22.21,0,0,0,19.42-10.94l11.22,5.75c-5.72,9-14.93,16.92-30.64,16.92C342.71,77.82,325.54,62,325.54,38.91Z"
            transform="translate(-2.42)"
            style="fill:#8a8a8d"
          />
          <path d="M432.84,1.24h6V64.85h33V76.46H425.7v-68A7.16,7.16,0,0,1,432.84,1.24Z" transform="translate(-2.42)" style="fill:#8a8a8d" />
          <path
            d="M510,1.24h44.16V12.86H516V32.37h37.38V44H516V64.85h38.16V76.46h-51.3v-68A7.16,7.16,0,0,1,510,1.24Z"
            transform="translate(-2.42)"
            style="fill:#8a8a8d"
          />
          <path d="M589.91,59.58a9.46,9.46,0,1,1-5.81,5.83A9.48,9.48,0,0,1,589.91,59.58Z" transform="translate(-2.42)" style="fill:#f1655b" />
        </svg>
      </div>
    </a>
  </div>
</template>
<script>
import logo from '@/assets/logos/article_logo.svg';
import logoFallback from '@/assets/logos/article_logo_234x30.png';

export default {
  props: ['homeUrl'],

  data() {
    return {
      logo,
    };
  },

  methods: {
    onLogoError() {
      this.logo = logoFallback;
    },
  },
};
</script>
<style lang="scss">
@import '~@article/pixel/dist/style/variables';

.page-header-logo {
  margin-right: 5px;

  @media (max-width: $small-breakpoint - 1) {
    margin-right: 0px;
  }

  .page-header-logo-image {
    width: 160px;
    height: 20.8px;

    @media (max-width: $small-breakpoint - 1) {
      width: 140px;
      height: 18.2px;
    }
  }

  @media (min-width: $tablet-breakpoint) {
    margin-bottom: 0px;

    .page-header-logo-image {
      width: 180px;
      height: 23.39px;
    }
  }
}
</style>
